import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CentralContentPageLayout from '../../Layout/CentralContentPageLayout';
import CentralGridLayout from '../../Layout/CentralGridLayout';
import Loader from '../../molecule/Loader';
import QuestionGender from '../../organism/QuestionGender';
import {
  useGetActiveDater,
  useGetAllQuestions,
  useGetQuestionDetailsById,
  useGetResponseForAllQuesionsByUser,
  usePatchSingleChoiceAnswer,
  usePostSingleChoiceAnswer,
} from '../../services/mutations';
import { localStorageKeys, useLocalStorage } from '../../utils/localStorageItems';
import { routeUrls } from '../../utils/constants';

const genderQuestionIdentifier = 13;

const FriendGenderQuestion = () => {
  const nav = useNavigate();
  const localStorageItem = useLocalStorage();
  const getAllQuestions = useGetAllQuestions();
  const getQuestionDetailsById = useGetQuestionDetailsById();
  const getResponseForAllQuesionsByUser = useGetResponseForAllQuesionsByUser();
  const postSingleChoiceAnswer = usePostSingleChoiceAnswer();
  const patchSingleChoiceAnswer = usePatchSingleChoiceAnswer();
  const getActiveDater = useGetActiveDater();

  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState(null);
  const [questionDetails, setQuestionDetails] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [patchId, setPatchId] = useState(null);
  const [error, setError] = useState('');

  const goHome = () => {
    setLoading(true);
    getActiveDater.mutate(
      {},
      {
        onSuccess: (response) => {
          localStorage.setItem(
            'activeDaterImage',
            response?.data?.payload?.user?.profile_pic,
          );
          localStorageItem.setLocalStorageItem(localStorageKeys.isLoggedIn, true);
          setLoading(false);
          nav(routeUrls.home);
        },
        onError: () => {
          localStorageItem.setLocalStorageItem(localStorageKeys.isLoggedIn, true);
          setLoading(false);
          nav(routeUrls.home);
        },
      },
    );
  };

  const fetchExistingAnswer = () => {
    const profileId = localStorageItem.getLocalStorageItem(localStorageKeys.profileId);
    if (!profileId) {
      return;
    }

    getResponseForAllQuesionsByUser.mutate(
      { user: profileId },
      {
        onSuccess: (response) => {
          const answer = response?.data?.payload?.results?.find(
            (item) =>
              item?.answer?.question?.identifier === genderQuestionIdentifier,
          );
          if (answer) {
            setSelectedAnswer(answer?.answer?.id || null);
            setPatchId(answer?.id || null);
          }
        },
      },
    );
  };

  const loadGenderQuestion = () => {
    setLoading(true);
    getAllQuestions.mutate(
      {},
      {
        onSuccess: (response) => {
          const genderQuestion = response?.data?.payload?.results?.find(
            (item) => item?.identifier === genderQuestionIdentifier,
          );

          if (!genderQuestion) {
            setLoading(false);
            goHome();
            return;
          }

          setQuestion(genderQuestion);
          getQuestionDetailsById.mutate(
            { id: genderQuestion.id },
            {
              onSuccess: (detailsResponse) => {
                setQuestionDetails(detailsResponse?.data?.payload);
                fetchExistingAnswer();
                setLoading(false);
              },
              onError: () => {
                setLoading(false);
                goHome();
              },
            },
          );
        },
        onError: () => {
          setLoading(false);
          goHome();
        },
      },
    );
  };

  const onNextClicked = () => {
    setError('');
    if (!selectedAnswer) {
      goHome();
      return;
    }

    const selectedChoice = questionDetails?.question_choices?.find(
      (choice) => choice.id === selectedAnswer,
    );
    const answerPayload = {
      value: selectedChoice?.value,
      visible: true,
      answer: selectedChoice?.id,
    };

    setLoading(true);
    if (patchId) {
      patchSingleChoiceAnswer.mutate(
        { id: patchId, answer: answerPayload },
        {
          onSuccess: goHome,
          onError: () => {
            setLoading(false);
            setError('Something went wrong, please try again');
          },
        },
      );
      return;
    }

    postSingleChoiceAnswer.mutate(answerPayload, {
      onSuccess: goHome,
      onError: (postError) => {
        if (postError?.response?.status === 400) {
          goHome();
        } else {
          setLoading(false);
          setError('Something went wrong, please try again');
        }
      },
    });
  };

  useEffect(() => {
    loadGenderQuestion();
  }, []);

  return (
    <>
      <Loader open={loading} />
      <CentralContentPageLayout>
        <CentralGridLayout>
          <QuestionGender
            displayText={`${question?.name || 'How do you describe your gender?'} (Optional)`}
            onBackClicked={goHome}
            error={error}
            onNextClicked={onNextClicked}
            answerChoices={questionDetails?.question_choices}
            selectedValue={selectedAnswer}
            onClickCallBack={setSelectedAnswer}
            showBackButton={false}
            showVisibility={false}
          />
        </CentralGridLayout>
      </CentralContentPageLayout>
    </>
  );
};

export default FriendGenderQuestion;
